function fetchData(dispatch, components, params, location) {
  const components_ = components.map(c => c.children || c);
  const promises = components_
    .filter(component => component.fetchData)
    .map(component => component.fetchData(dispatch, params, location));

  return Promise.all(promises);
}

export default fetchData;



// WEBPACK FOOTER //
// ./fetch-data.js